import { render, staticRenderFns } from "./transactionHold2.vue?vue&type=template&id=6aeaca9e&"
import script from "./transactionHold2.vue?vue&type=script&lang=js&"
export * from "./transactionHold2.vue?vue&type=script&lang=js&"
import style0 from "./transactionHold2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports